import { apiClient } from '../../../ruutsApi/client'
import endpoints from '../../../ruutsApi/endpoints'
import { unwrapVoid } from '../../../ruutsApi/normalize'

// POST /v1/monitoring/events answers with a raw string (res.send), not an envelope,
// so the response body is intentionally discarded — see the PR 8 mutation response-shape table.
export const createMonitoringEvent = async ({
  data,
}: {
  data: Record<string, unknown>
}): Promise<void> => {
  const response = await apiClient.post(endpoints.events, data)
  return unwrapVoid(response)
}
